import { useHistory } from "react-router";
import { useEffect } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "utilities/i18n";
import { DISMISS, useNotification } from "collections";

/**
 * Notify the user that their changes have been saved when they navigate away from the form.
 * @constructor
 */
export const ChangeSaveNotification: React.FC = () => {
  const h = useHistory();
  const { t } = useTranslation();
  const [addNotification] = useNotification();
  const { submitCount } = useFormikContext();
  useEffect(() => {
    //Window listener returns its own method to remove its handler.
    return h.listen(() => {
      if (submitCount === 0) return;
      addNotification({
        type: "success",
        id: "SavedNCServiceNowEdits",
        dismiss: DISMISS.DEFAULT,
        message: t("SAVE_SUCCESS"),
        persistThroughNav: true
      });
    });
    // omit t and addNotification from deps, otherwise causes useEffect to call infinitely with no usefulness
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount, h]);
  return <></>;
};
